import * as React from "react";
import ILabelProps from "./ILabel";
import "../../../assets/sass/widgets/datePickerWidget.scss";

/**
 * @class Label
 * @param props
 * @constructor
 * @category components
 * @description components used for showing various type of labels used in other components and its sections
 */
const Label: React.FC<ILabelProps> = (props) => {
    const { schema } = props;
    return (
        <div className={schema.const && schema.const.label ? "label-contianer" : ""}>
            {schema.const.label && (<label>
                {schema.const.label}
                    <span>
                        <br />
                        {schema.const.subtitle ? schema.const.subtitle : ""}
                    </span>
            </label>)}
            
            {schema.const.helpText && (
                <div className="info-icon">
                    <span className="tooltip">{schema.const.helpText}</span>
                </div>
            )}
        </div>
    );
};
export default Label;
